module.exports = __webpack_public_path__ + "static/media/creditcard_website.f71a59bb.webp";